import { SharedService } from '../shared.service';
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { EnBWUnit } from 'src/app/core/models/EnBWUnit';

@Component({
  standalone: false,
  selector: 'fdb-enbwunit',
  templateUrl: './enbwunit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./enbwunit.component.scss']
})
export class EnbwUnitComponent implements OnInit {
  public UIControlTyp = UIControlTyp;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.EnBWUnits.map(unit => Number(unit.id)) :
      Number(this.EnBWUnit ? this.EnBWUnit.id : 0);
    return val;
  }
  set values(val: number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.EnBWUnits = val.map(id => this.getObjectFromList(id));
      this.getRefreshSelectedValue();
    } else {
      this.EnBWUnit = this.getObjectFromList(val as number);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public EnBWUnits: EnBWUnit[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public EnBWUnit: EnBWUnit;
  /** Enthält die Werte die angezeigt werden dürfen */
  public EnBWUnitList: EnBWUnit[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: EnBWUnit[] = [];

  constructor(private modulService: SharedService) { }

  ngOnInit() {
    this.initenbwunits();
  }

  initenbwunits() {
    this.modulService.getEnBWUnits(true)
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.EnBWUnitList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.EnBWUnitList.unshift(new EnBWUnit().getEmptyModel());
          }
          this.getRefreshSelectedValue();
        }
      },
        err => this.modulService.showNotification(err, 'error'));
  }

  filterenbwunit(value: string) {
    this.EnBWUnitList = this.OriginalValues
      .filter((s) => (s.name || '').toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(): void {
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: string | number): EnBWUnit {
    if (id === 0 || id === "") {
      return new EnBWUnit().getEmptyModel();
    }
    id = Number(id);
    if (isNaN(id)) {
      return new EnBWUnit().getEmptyModel();
    }

    const find = this.OriginalValues.find(unit => Number(unit.id) === id);
    return find ? find : new EnBWUnit().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.EnBWUnit ? this.EnBWUnit.id : 0));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.EnBWUnits = this.EnBWUnits
      .map(x => this.OriginalValues.find(y => Number(y.id) === Number(x.id)) || x)
      .filter(x => !!x);
  }
}
